import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Twitter, Linkedin, Github, Mail, Phone, MapPin } from 'lucide-react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-col">
            <h3>SRITHA <span className="black-text">SOLUTIONS</span></h3>
            <p>Building scalable digital solutions for modern businesses. We transform ideas into powerful digital products.</p>
            <div className="social-links">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer"><Facebook size={20} /></a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer"><Twitter size={20} /></a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer"><Linkedin size={20} /></a>
              <a href="https://github.com" target="_blank" rel="noopener noreferrer"><Github size={20} /></a>
            </div>
          </div>

          <div className="footer-col">
            <h4>Quick Links</h4>
            <Link to="/about">About Us</Link>
            <Link to="/services">Services</Link>
            <Link to="/industries">Industries</Link>
            <Link to="/careers">Careers</Link>
          </div>

          <div className="footer-col">
            <h4>Services</h4>
            <Link to="/services/web-development">Web Development</Link>
            <Link to="/services/mobile-apps">Mobile Apps</Link>
            <Link to="/services/saas-development">SaaS Development</Link>
            <Link to="/services/cloud-solutions">Cloud Solutions</Link>
            <Link to="/services/it-consulting">IT Consulting</Link>
          </div>

          <div className="footer-col">
            <h4>Industries</h4>
            <span className="industry-name">FinTech</span>
            <span className="industry-name">Healthcare</span>
            <span className="industry-name">EdTech</span>
            <span className="industry-name">E-commerce</span>
            <span className="industry-name">Logistics</span>
            <span className="industry-name">SaaS Startups</span>
          </div>

          <div className="footer-col">
            <h4>Contact</h4>
            <div className="contact-info">
              <Mail size={16} />
              <span>contact@sritha-solutions.com</span>
            </div>
            <div className="contact-info">
              <Phone size={16} />
              <span>+91 8074239533</span>
            </div>
            <div className="contact-info">
              <MapPin size={16} />
              <span>Hyderabad, Telangana, India</span>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; 2024 Sritha Solutions. All rights reserved.</p>
          <div className="footer-legal">
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/terms">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;